import { render, staticRenderFns } from "./CreateAgreement.vue?vue&type=template&id=68f5bf1a"
import script from "./CreateAgreement.vue?vue&type=script&lang=js"
export * from "./CreateAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports